import React, { useState, useEffect, useRef } from 'react';
import './AboutMe.css';

import x from '../../asset/x.svg';
import backToMenu from '../../asset/back_to_menu.svg';
import clickMenu from "../../asset/clickMenu.svg";
import englishBelow from '../../asset/english_below.svg';

import camera from '../../asset/camera.svg';
import graphic from '../../asset/graphic.svg';
import coding from '../../asset/coding.svg';
import travel from '../../asset/travel.svg';

import emptyCamera from '../../asset/camera_empty.svg';
import emptyGraphic from '../../asset/graphic_empty.svg';
import emptyCoding from '../../asset/coding_empty.svg';
import emptyTravel from '../../asset/travel_empty.svg';

import mySelf from '../../asset/mySelf.png';
import thisIsMe from '../../asset/thisIsMe.svg';

import background from "../../asset/about_me_background.png";

function AboutMe({showAboutMeModal, setShowAboutMeModal, handleBackToMenuClick, resetIcons}) {
    
    const [showAboutMeSecondModal, setShowAboutMeSecondModal] = useState(false);
    const [showAboutMeClickMenuImages, setShowAboutMeClickMenuImages] = useState(false);
    const [aboutMeClickMenuImageFadeOut, setAboutMeClickMenuImageFadeOut] = useState(false);

    const [selectedCamera, setSelectedCamera] = useState(emptyCamera);
    const [selectedGraphic, setSelectedGraphic] = useState(emptyGraphic);
    const [selectedCoding, setSelectedCoding] = useState(emptyCoding);
    const [selectedTravel, setSelectedTravel] = useState(emptyTravel);

    useEffect(() => {
        if (showAboutMeModal) {
            const showImagesTimer = setTimeout(() => {
                setShowAboutMeClickMenuImages(true);
            }, 800);

            const fadeOutTimer = setTimeout(() => {
                setAboutMeClickMenuImageFadeOut(true);
            }, 4000);

            const secondModalTimer = setTimeout(() => {
                setShowAboutMeSecondModal(true);
            }, 1000);

            return () => {
                clearTimeout(showImagesTimer);
                clearTimeout(fadeOutTimer);
                clearTimeout(secondModalTimer);
            };
        } else {
            setShowAboutMeClickMenuImages(false);
            setAboutMeClickMenuImageFadeOut(false);
            setShowAboutMeSecondModal(false);
        }
    }, [showAboutMeModal]);

    const handleAboutMeCategoryImageClick = (setImageFunc, ref) => {
        setImageFunc();  // 이미지 상태 업데이트
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' }); // 이미지가 있는 곳으로 부드럽게 스크롤
    };

    const cameraRef = useRef(null);
    const graphicRef = useRef(null);
    const codingRef = useRef(null);
    const travelRef = useRef(null);

    const englishSectionRef = useRef(null);

    const handleScrollToEnglishSection = () => {
        // 영어 섹션으로 부드럽게 스크롤
        if (englishSectionRef.current) {
        englishSectionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div>
            {showAboutMeModal && (
                <div>
                    <div className="aboutMe-modal-shadow">
                    </div>

                    <div className="aboutMe-modal">
                        <div className="aboutMe-modal-upper">
                            <img
                                src={x}
                                alt={"x"}
                                onClick={
                                    () => {
                                        setShowAboutMeModal(false);
                                        setSelectedCamera(emptyCamera);
                                        setSelectedGraphic(emptyGraphic);
                                        setSelectedCoding(emptyCoding);
                                        setSelectedTravel(emptyTravel);
                                        resetIcons();
                                }}
                                className="aboutMe-modal-upper-x-big"
                                style={{
                                    width: "auto",
                                    height: "40px",
                                    float: "left",
                                    marginTop: "5px",
                                    marginLeft: "3%"
                                }}
                            />
                            <img
                                src={backToMenu}
                                alt={"back-to-menu"}
                                className="aboutMe-modal-upper-back"
                                onClick={handleBackToMenuClick}
                                style={{
                                    width: "auto",
                                    height: "40px",
                                    float: "right",
                                    marginTop: "5px",
                                    marginRight: "3%"
                                }}
                            />
                        </div>
                        <div className="aboutMe-modal-lower">
                            <div
                                style={{
                                    width: "70%",
                                    height: "auto",
                                    marginTop: "20px",
                                    marginLeft: "10px",
                                    marginBottom: "20px",
                                    backgroundColor: "rgba(255, 203, 235, 0.8)",
                                    border: "1px solid rgba(47, 49, 45, 1)",
                                    borderRadius: "15px",
                                    overflowY: "auto",
                                    float: "left"
                                }}
                            >
                                <img
                                    src={background}
                                    alt=""
                                    style={{
                                        position: "fixed",
                                        width: "55%",
                                        height: "auto",
                                        marginTop: "20px",
                                        marginLeft: "10px",
                                        pointerEvents: "none",
                                        opacity: "0.1"
                                    }}
                                />
                                <div
                                    className="about-me"
                                >
                                    <img
                                        src={englishBelow}
                                        alt="English Below"
                                        className="english-below"
                                        style={{
                                            width: "200px",
                                            height: "auto"
                                        }}
                                        onClick={handleScrollToEnglishSection}
                                    />
                                    <p>
                                        <br/>
                                        안녕하세요, 제 이름은 권은정입니다. 😊<br/><br/>

                                        저는 창작하는 사람입니다, <strong>다양한 도구를 활용하여 융합적이고 독창적인</strong> 결과물을 만들어 냅니다.<br/>
                                        <img src={selectedCamera} alt={""} ref={cameraRef} style={{ width: "114px", height: "63px", verticalAlign: "middle" }} /> 분야에 8년의 경력이 있으며, 뉴스, 다큐멘터리, 단편 영화, 광고 홍보, 뮤직 비디오 등의 분야에서 기획부터 후반 작업까지 1인 또는 협력 제작의 경험이 있습니다.<br/>
                                        <img src={selectedGraphic} alt={""} ref={graphicRef} style={{width: "72px", height: "66px", verticalAlign: "middle"}} /> 분야에서도 활동하였으며, <u>제 홈페이지 및 다양한 웹 작업물들 또한 제가 직접 디자인 한 것</u>입니다.<br/>
                                        더불어 웹 프론트엔드 <img src={selectedCoding} alt={""} ref={codingRef} style={{width: "90px", height: "75px", verticalAlign: "middle"}} /> 분야에 4년의 경력이 있습니다. 스타트업에서 근무했었으며 현재는 독립 제작자 및 프리랜서로 <u>크리에이티브 코딩, 웹 아트, 인터랙티브 웹에 중점을 두고 작업</u>하고 있습니다.<br/><br/>
                                        또한 미디어 아트 분야로 작업 영역을 확장히기 위해 공부하고 있으며, 곧 첫번째 미시어 파사드 전시를 앞두고 있습니다.<br/>
                                        <br/><br/>

                                        저는 늘 탐색하고, 직접 찾아나서며, 꾸준히 길 위에 오르는 사람입니다.<br/>
                                        <u>7년간 배낭을 메고 아프리카 30개국을 포함한 세계 70여개국</u>을 <img src={selectedTravel} alt={""} ref={travelRef} style={{width: "63px", height: "96px", verticalAlign: "middle"}} />하였으며, 그 과정에서 다듬어 온 <strong>세계관을 소중히 키워가며 창작</strong>합니다.<br/>
                                        모두에게 공정한 기회가 주어지는 세상, 개성과 다양성, 각자의 정체성이 있는 그대로 중시되는 세상을 꿈꾸고 바랍니다.<br/><br/>
                                        
                                        다양한 방식으로 <span className="highlight">저의 세계관을, 그리고 당신의 메세지를 전달하기 위해 노력</span>하려 합니다.<br/><br/>
                                    </p>
                                    <p ref={englishSectionRef}>
                                        Hello, my name is Eunjung Kwon. 😊<br/>
                                        I’m a creator who produces integrated and original outcomes using diverse tools and methods.<br/><br/>

                                        I have eight years of experience in video production, covering news, documentaries, short films, promotional advertisements, and music videos. My roles have encompassed the full process, from planning to post-production, both as a solo creator and in collaborative environments.<br/>
                                        Also, I’ve actively worked in graphic design. My website and various other web projects are all self-designed.<br/>
                                        In the realm of web development, I have four years of experience focusing on front-end work. After working at a startup, I now operate as an independent creator and freelancer, with a particular interest in creative coding, web art, and interactive web experiences.<br/>
                                        Recently, I’ve been expanding my creative scope into media art and am preparing my first media facade exhibition.<br/>
                                        I have a deep passion for drawing and making things, which has led me to participate in several exhibitions. Writing is another medium I enjoy, allowing me to refine and articulate my thoughts.<br/><br/>

                                        I consider myself an explorer—constantly seeking out new experiences and boldly setting off on new journeys. Over seven years, I traveled to 80 countries, including 30 in Africa, carrying only a backpack. These adventures have shaped my worldview, and I treasure the perspectives I’ve gained, using them as a foundation for my creative endeavors.<br/>
                                        I aspire to a world where fairness, individuality, diversity, and personal identity are valued and respected.<br/><br/>

                                        Through my work, I seek to express this vision and help communicate your message in meaningful ways.
                                    </p>
                                </div>
                            </div>
                            <div
                                className="about-me-menu"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    height: "auto",
                                    paddingTop: "20px",
                                    borderRadius: "15px",
                                }}
                            >
                                <img
                                    src={camera}
                                    alt="camera"
                                    style={{
                                        width: "205px",
                                        height: "114px",
                                        marginBottom: "10px",
                                        transition: "transform 0.3s ease", // 부드럽게 변화
                                    }}
                                    onClick={() => handleAboutMeCategoryImageClick(() => setSelectedCamera(camera), cameraRef)} // 이미지 클릭 시 상태 변경
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                />
                                <img
                                    src={graphic}
                                    alt="graphic"
                                    style={{
                                        width: "130px",
                                        height: "119px",
                                        marginBottom: "10px",
                                        transition: "transform 0.3s ease",
                                    }}
                                    onClick={() => handleAboutMeCategoryImageClick(() => setSelectedGraphic(graphic), graphicRef)}
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                />
                                <img
                                    src={coding}
                                    alt="coding"
                                    style={{
                                        width: "162px",
                                        height: "134.5px",
                                        marginBottom: "10px",
                                        transition: "transform 0.3s ease",
                                    }}
                                    onClick={() => handleAboutMeCategoryImageClick(() => setSelectedCoding(coding), codingRef)}
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                />
                                <img
                                    src={travel}
                                    alt="travel"
                                    style={{
                                        width: "114px",
                                        height: "173px",
                                        transition: "transform 0.3s ease",
                                    }}
                                    onClick={() => handleAboutMeCategoryImageClick(() => setSelectedTravel(travel), travelRef)}
                                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showAboutMeSecondModal && (
                <div className="aboutMe-second-modal">
                    <div className="aboutMe-second-modal-upper">
                        <img
                            src={x}
                            alt={"x"}
                            onClick={() => setShowAboutMeSecondModal(false)}
                            className="aboutMe-modal-upper-x-small"
                            style={{
                                width: "auto",
                                height: "20px",
                                margin: "2%"
                            }}
                        />
                    </div>
                    <div className="aboutMe-second-modal-lower">
                        <img
                            src={mySelf}
                            alt={"myself"}
                            style={{
                                width: "100%",
                                height: "auto",
                                paddingTop: "1%"
                                // borderBottomLeftRadius: "15px",
                                // borderBottomRightRadius: "15px",
                            }}
                        />
                        <img
                            src={thisIsMe}
                            alt={"this-is-me"}
                            style={{
                                width: "80%",
                                height: "auto",
                                position: "absolute",
                                left: "10%",
                                bottom: "5%"
                            }}
                        />
                    </div>
                    <div className="aboutMe-second-modal-bottom">
                    </div>
                </div>
            )}
            {showAboutMeClickMenuImages && (
                <>
                    <img
                    src={clickMenu}
                    alt="Click Menu"
                    className={`click-menu-image ${aboutMeClickMenuImageFadeOut ? 'fade-out' : ''}`}
                    />
                </>
            )}
        </div>
    )
}

export default AboutMe;